import React from 'react';
import Crop169Icon from '@mui/icons-material/Crop169';
import AddCircleIcon from '@mui/icons-material/AddCircle';

const AddRowIcon = ({ direction = 'top' }) => {
	const offset = direction === 'top' ? -6 : 6;
	const rowOffset = direction === 'top' ? 6 : -7;

	const translateY = direction === 'top' ? `calc(-100% - ${offset}px)` : `calc(${offset}px)`;

	return (
		<span
			style={{
				position: 'relative',
				display: 'inline-flex',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<Crop169Icon
				style={{
					display: 'block',
					marginTop: `${rowOffset}px`,
				}}
				size='small'
			/>

			<AddCircleIcon
				size='small'
				style={{
					position: 'absolute',
					left: '50%',
					transform: `translateX(-50%) translateY(${translateY})`,
					backgroundColor: 'white',
					borderRadius: '50%',
					width: 12,
					height: 12,
					fontSize: '24px',
					pointerEvents: 'none',
				}}
			/>
		</span>
	);
};

export default AddRowIcon;
